import Vue from 'vue';
export const useLangJs = () => {
    let Lang = Vue.prototype.Lang;
    /**
     * Gets the translation value for the given key
     *
     * @param {string} prepend - Translations source, defaults to "employerdashboard::pages/"
     * @param {string} key - Translation key
     * @param {Object} inserts - Replacement values for string interpolation, given as key:value
     * @returns Translation value or undefined
     */
    function Trans(key, inserts, prepend = "employerdashboard::pages/") {
        return Lang.get(prepend + key, inserts);
    }
    return {
        Lang,
        Trans
    };
};
